import type { App } from 'vue'

export function usePreventReclick(app: App) {
    // 防连点指令
    app.directive('prevent-reclick', {
        mounted(el, binding) {
            const { value: fn, arg: delay = 1000 } = binding
            let isLocked = false

            el.addEventListener('click', async (e) => {
                if (isLocked) return

                isLocked = true
                el.style.opacity = '0.6'
                el.style.cursor = 'not-allowed'

                try {
                    await fn(e)
                } finally {
                    setTimeout(() => {
                        isLocked = false
                        el.style.opacity = '1'
                        el.style.cursor = 'pointer'
                    }, Number(delay))
                }
            })
        },
    })
}
